import {Component, OnInit} from '@angular/core';
import {NzTableQueryParams} from 'ng-zorro-antd/table';
import {StpRegistrationStorageService} from '../../services/stp-registration-storage.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { StpApplicationDto } from '../../DTO/stp_application_dto.model';

@Component({
  selector: 'app-previous-stp-application',
  templateUrl: './previous-stp-application.component.html',
  styleUrls: ['./previous-stp-application.component.scss']
})
export class PreviousStpApplicationComponent implements OnInit {
  stpApplicationDto: StpApplicationDto[] = [];

  page = 1;
  size = 10;
  total = 0;
  sortBy = 'id';
  sortDir = 'desc';

  loading = false;
  stpList: any;
  allStpList: any;

  searchingForm: FormGroup = this.fb.group({
    stpApplicationId: [null],
    stpIsApproved: [null],
    stpIsNotApproved: [null],
    currectionNeeded: [null],
    stpName: [null],
    stpOwnerShipStatusId: [null],
    sysDistrictId: [null],
    occupationName: [null],
    submissionStatusId: [null],
    pendingStp: [null],
    registrationNo: [null],
  });

  constructor(
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.getPreviousStpApplicationList();
  }

  getPreviousStpApplicationList(): void {
    this.loading = true;
    this.stpRegistrationStorageService.getPreviousStpApplication(
      this.page,
      this.size,
      this.searchingForm.value,
      this.sortBy,
      this.sortDir
    ).subscribe({
      next: (res) => {
        this.stpList = res.data.content;
        this.total = res.data.totalElements;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    this.size = pageSize;
    this.page = pageIndex;
    const currentSort = sort.find(s => s.value !== null);
    if (currentSort) {
      this.sortBy = currentSort.key;
      this.sortDir = currentSort.value === 'ascend' ? 'asc' : 'desc';
    }
    this.getPreviousStpApplicationList(); // ✅ fetch new page from backend
  }


  onSearch(): void {
    this.page = 1;
  }

  onRefresh(): void {
    this.getPreviousStpApplicationList();
  }
}
